import { createStore } from 'reusable';
import { useState } from 'react';

export const useSnackbarMessage = createStore(() => useState(''));
